// @ts-check

import {
  AUTHENTICATION_REQUIRED,
  IS_IN_MAIN_NAV,
  ROUTE_NAME
} from '@/router/meta'
import SalaryIndex from '@/views/salary/SalaryIndex.vue'
import { setupDatatableRoute } from './helpers'

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_EMPLOYEE = {
  path: 'employee',
  name: 'salary_employee',
  meta: {
    scrollToTop: true
  },
  component: () => import('@/components/salaries/forms/SalaryEmployeeForm.vue')
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_TAX_CARD = {
  path: 'tax-card',
  name: 'salary_tax_card',
  meta: {
    scrollToTop: true
  },
  component: () => import('@/components/salaries/forms/SalaryTaxCardForm.vue')
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_DETAILS = {
  path: 'details',
  name: 'salary_details',
  meta: {
    scrollToTop: true
  },
  component: () => import('@/components/salaries/forms/SalaryDetailsForm.vue')
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_SUMMARY = {
  path: 'summary',
  name: 'salary_summary',
  meta: {
    scrollToTop: true
  },
  component: () => import('@/components/salaries/SalarySummary.vue')
}

export const SALARY_FORM = {
  SALARY_EMPLOYEE,
  SALARY_TAX_CARD,
  SALARY_DETAILS,
  SALARY_SUMMARY
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_LIST = {
  path: '/salaries',
  component: SalaryIndex,
  name: 'salaries',
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [IS_IN_MAIN_NAV]: true,
    icon: '$chart-bar',
    [ROUTE_NAME]: 'salaries'
  },
  beforeEnter: setupDatatableRoute
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_VIEW = {
  path: '/salaries/:id',
  component: () => import('@/views/salary/SalaryView.vue'),
  name: 'view_payslip_input',
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [ROUTE_NAME]: 'view_payslip_input'
  },
  props: (route) => ({ id: +route.params.id })
}

/** @type {import('vue-router').RouteRecordRaw} */
export const SALARY_EDIT = {
  path: '/salaries/:id(\\d+)?/edit',
  component: () => import('@/views/salary/SalaryCreate.vue'),
  name: 'edit_salary',
  meta: {
    [AUTHENTICATION_REQUIRED]: true,
    [ROUTE_NAME]: 'edit_salary'
  },
  children: Object.values(SALARY_FORM),
  redirect: (to) => ({ params: to.params, name: SALARY_EMPLOYEE.name }),
  props: (route) => ({ id: +route.params.id })
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export const salaryRoutes = [SALARY_LIST, SALARY_VIEW, SALARY_EDIT]

export default salaryRoutes
